/* eslint-disable import/no-anonymous-default-export */
import { Button, Form, Input, notification, Progress, Select, Space, Table } from "antd";
import { FilterValue } from "antd/lib/table/interface";
import moment from "moment";
import { useContext, useEffect, useRef, useState } from "react";
import DataFilter from "../common/components/DataFilter";
import DataTable, { DataTableRef } from "../common/components/DataTable";
import MainLayout from "../common/components/MainLayout";
import styled from "styled-components";
import useLotesPrecargaAPI, { LotePrecarga } from "./useLotesPrecargaAPI";
import AppStateContext from "../common/contexts/AppStateContext";
import axios, { AxiosError } from "axios";

const StyledProgress = styled(Progress)`
width:100%;

`;

const ProgressContainer =  styled.div`
margin-top: 1rem;
padding: 1rem;
background: white;
& > span
{
    font-size: 0.7rem;
    font-weight: 600;
}
`;

export default () => {
    const api = useLotesPrecargaAPI();
    const refTable = useRef<DataTableRef>(null!);
    const appStateContext = useContext(AppStateContext);
    const [percent, setPercent] = useState(0);
    const [loading, setLoading] = useState(false);
    const [nroLoteFilterForm] = Form.useForm();
    //const appStateContext = useContext(AppStateContext);
    const instances = appStateContext?.instances ?? {};
    
    const generateFilters = (filters:Record<string, FilterValue | null>) => {
        return [
            filters?.Nombre != null ?  `contains(NroLote,'${filters!.Nombre![0]}')` : "",
            
        ];
    }

    const radarPreload = async () => {
        setLoading(true);
        
        let response;
        try {
            response = await api.radarPreload();
        } catch (error) {
            setLoading(false);
        }

        if(!response?.data)
        {
                notification.error({
                    message:"Error al realizar la precarga"
                });
        }
    };

    const handleDeleteLotes = async (idLote : number) => {
        let response;
        try {
            response = await api.delete(idLote);
        } catch (error) {

        }
            if (response?.error) {
                const error = response.error as AxiosError;
            
                notification.error({
                message: [400, 404].includes(error.response?.status ?? 0)
                    ? `Error al eliminar el lote ${idLote}. Las infracciones ya fueron procesadas`
                    : "Error al eliminar el lote",
                    key: "Noti400Lote"
                });
            }
        }

    // useEffect(() => {
    //     setLoading(appStateContext?.CargandoInfracciones ?? false);
    //     if (appStateContext?.CargandoInfracciones == false) {
    //         refTable.current.loadItems();
    //     }
    // }, [appStateContext?.CargandoInfracciones]);

    // useEffect(() => {
    //     if (appStateContext?.PorcentajeCargaInfracciones == 0) {
    //         setTimeout(() => {
    //             setPercent(0);
    //         }, 3000);
    //     }
    //     else {
    //         setPercent(appStateContext?.PorcentajeCargaInfracciones ?? 0)
    //     }
    // }, [appStateContext?.PorcentajeCargaInfracciones])

    return (
        <MainLayout >
                <DataTable<LotePrecarga, LotePrecarga>
                    list={api.list}
                    delete={handleDeleteLotes}
                    deleteMultipleAction
                    defaultSortOrder={"NroLote desc"}
                    selectionType='checkbox'
                    title={"Lotes de precarga"}
                    generateFilters={generateFilters}
                    deleteItemAction
                    deleteItemActionConfirmMessage={(item) => `¿Eliminar lote ${item.NroLote}?`}
                    defaultPageSize={5}
                    ref={refTable}
                    /*tableActions={[{
                        action:radarPreload,
                        key:'radar-preload',
                        label:'Iniciar precarga',
                        checkDisabled:()=>loading
                    }]}*/

                >

                    <Table.Column<LotePrecarga>
                        width={`20%`}
                        title="Fecha"
                        dataIndex={"FechaHora"}
                        sorter
                        render={(value, record, index) => moment(value).format("DD/MM/YYYY HH:mm:ss")}
                        sortDirections={["ascend", "descend", "ascend"]}

                    />

                    <Table.Column<LotePrecarga>
                        width={`35%`}
                        title="Nro. de lote"
                        dataIndex={"NroLote"}
                        sorter
                        defaultSortOrder={'descend'}
                        sortDirections={["ascend", "descend", "ascend"]}
                        filterDropdown={(props) => {
                            return (
                                <DataFilter filterDropdownProps={props} form={nroLoteFilterForm} >
                                    <Form.Item name={"NroLote"} style={{ marginBottom: 10 }}>
                                        <Input placeholder='Nro. de lote...' />
                                    </Form.Item>
                                </DataFilter>
                            );
                        }
                        }

                    />

                    <Table.Column<LotePrecarga>
                        width={`30%`}
                        title="Cantidad"
                        dataIndex={"CantidadInfracciones"}
                        sorter
                        sortDirections={["ascend", "descend", "ascend"]}

                    />
                </DataTable>

                {/* <ProgressContainer>
                    <span>Ultima carga: {appStateContext?.UltimaCargaInfracciones?.format("DD/MM/YYYY HH:mm:ss") ?? "-"} {appStateContext?.CargandoInfracciones || loading ? "(Carga en progreso... No cierre la ventana)":""}</span>
                    <StyledProgress percent={percent} />
                </ProgressContainer> */}
                {Object.keys(instances).map((key) => {
                const state = instances[key];
                return (
                    <ProgressContainer key={key}>
                        <div style={{ fontWeight: 'bold' }}>Instancia de Precarga {key}</div>
                        <span>
                            Ultima carga: {state.UltimaCargaInfracciones?.format("DD/MM/YYYY HH:mm:ss") ?? "-"} 
                            {state.CargandoInfracciones ? " (Procesando... - Configuración producción: " + (state.PrecargaConfiguracionProduccionNombre ?? '-') : ""}
                        </span>
                        <StyledProgress 
                            percent={state.PorcentajeCargaInfracciones} 
                            status={state.CargandoInfracciones ? "active" : "normal"}
                        />
                    </ProgressContainer>
                );
            })}
        </MainLayout>
    );

};